import { memo, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SidebarItem } from "./SidebarItem";
import type { NavSection } from "./sidebarData";
import { useNavPermissions } from "./useNavPermissions";

interface SidebarSectionProps {
  section: NavSection;
  collapsed: boolean;
}

export const SidebarSection = memo(function SidebarSection({
  section,
  collapsed,
}: SidebarSectionProps) {
  const { canViewItem } = useNavPermissions();
  const location = useLocation();
  const title = section.title;

  const items = useMemo(
    () => section.items.filter(canViewItem),
    [section.items, canViewItem],
  );

  if (items.length === 0) return null;

  return (
    <div>
      {title && !collapsed && (
        <div className="mb-1.5 px-3 text-[10px] font-semibold uppercase tracking-[0.08em] text-sidebar-foreground/20">
          {title}
        </div>
      )}
      <div className="space-y-0.5">
        {items.map((item) => (
          <SidebarItem
            key={item.path}
            item={item}
            collapsed={collapsed}
            isActive={
              location.pathname === item.path ||
              location.pathname.startsWith(item.path + "/")
            }
          />
        ))}
      </div>
    </div>
  );
});
